import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { withPrevButton } = {}) => ({
  prevButton: { paddingLeft: 0 },
  buttons: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: withPrevButton ? 'space-between' : 'end',
    width: '100%',
    '& #prev-button': {
      color: theme.palette.primary1,
    },
    '& #next-button': {
      minWidth: 110,
      paddingLeft: 20,
      paddingRight: 20,
    },
    [theme.breakpoints.down('lg')]: {
      flexGrow: 1,
      alignItems: 'end',
      '& #next-button': {
        width: 200,
      },
    },
    [theme.breakpoints.down('md')]: {
      '& #next-button': {
        height: 44,
      },
      ...(withPrevButton && {
        '& button': {
          '&:nth-child(2)': {
            width: '200px',
          },
          '&:nth-child(1)': {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      }),
    },
    [theme.breakpoints.down('sm')]: {
      '& #prev-button': {
        width: 'fit-content !important',
      },
      '& #next-button': {
        width: withPrevButton ? '47% !important' : '100% !important',
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        flexGrow: 1,
        alignItems: 'end',
        '& #next-button': {
          width: 200,
        },
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        '& #next-button': {
          height: 44,
        },
        ...(withPrevButton && {
          '& button': {
            '&:nth-child(2)': {
              width: '200px',
            },
            '&:nth-child(1)': {
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        }),
      }),
    },
  },
}));
